module.exports = __webpack_public_path__ + "media/images/ns-app-header-white-logo-bfb2acfbb61f4063ce84ae8e89318570.svg";